import React from 'react';
import { toast } from 'react-toastify';
import URLSearchParams from '@ungap/url-search-params';
import { getIsVerboseOn } from './selectors';
import getStore from './index';
import { parseBool } from '../helpers/parsers';

export function isVerboseOn(payload = {}) {
  const url = new URL(window.location.href.replace('#', '&'));
  const search = new URLSearchParams(url.search);
  return (
    getIsVerboseOn(getStore().getState()) ||
    payload.isVerboseOn ||
    (search.has('verbose') &&
      (!search.get('verbose') || parseBool(search.get('verbose'))))
  );
}

export function showNativeCall(payload) {
  if (!isVerboseOn(payload)) return;

  const title = 'Call from Native';
  toast.info(getToastBody(title, payload));
  console.log(title, payload); // eslint-disable-line no-console
}

export function showWebviewCall(payload) {
  if (!isVerboseOn(payload)) return;

  const title = 'Call from Webview';
  toast.success(getToastBody(title, payload));
  console.log(title, payload); // eslint-disable-line no-console
}

function getToastBody(message, payload) {
  return (
    <div>
      <p style={{ textAlign: 'center', textDecoration: 'underline' }}>
        <strong>{message}:</strong>
      </p>
      <pre style={{ whiteSpace: 'pre-wrap' }}>
        {JSON.stringify(payload, null, 2)}
      </pre>
    </div>
  );
}
